
<section class="hero" aria-labelledby="hero-title">
  <div class="hero-content">
    <h1 id="hero-title" class="subtitle">{{"BANNER1_TITLE" | translate}}</h1>
    <ul class="features" role="list">
      <li class="publish-point">
        <span class="point-text">{{"BANNER1_TEXT1" | translate}}</span>
      </li>
      <li class="publish-point">
        <span class="point-text">{{"BANNER1_TEXT2" | translate}}</span>
      </li>
      <li class="publish-point">
        <span class="point-text">{{"BANNER1_TEXT3" | translate}}</span>
      </li>
      <li class="publish-point">
        <span class="point-text">{{"BANNER1_TEXT4" | translate}}</span>
      </li>
      <li class="publish-point">
        <span class="point-text">{{"BANNER1_TEXT5" | translate}}</span>
      </li>



    </ul>
    <div class="hero-buttons">
      <a [routerLink]="['/', currentLang(), 'pricing']" class="btn-primary" title="{{'BANNER1_BUTTON' | translate}}">{{'BANNER1_BUTTON' | translate}}</a>
 
    </div>
  </div>

  <div class="hero-image">
    <img src="/assets/images/image3.webp" width="488" height="304" class="w-100" [alt]="'BANNER1_TITLE' | translate" >
  </div>
</section>
